import React from 'react';
import ContentLayout from '../../../../components/ContentLayout';
import Tabs from '../../../../components/Tabs';
import props from '../../../../lib/contentLayoutProps/learning-at-kingston/primary-school/layoutProps';

import ict from './ict@large.jpg';
import pedagogy from './pedagogy@large.jpg';

const tabs = ['Pedagogy', 'Resources'];

/* eslint-disable react/prop-types */
export default class extends React.Component {
  state = {
    tab: 0,
  };

  render() {
    const { tab } = this.state;

    return (
      <ContentLayout {...props} locale="en" pageKey="ict-and-commitment-to-innovation">
        <h1>ICT & Commitment to Innovation</h1>
        <Tabs tabs={tabs} onChangeTab={index => this.setState({ tab: index })} />
        {tab === 0 && (
          <React.Fragment>
            <p>
              At Kingston, we are committed to use Digital Technology to enhance teaching and facilitate learning of our
              Transdisciplinary Programme of Inquiry. These technologies are used for the purpose of collaboration,
              creation, communication, design, analysis and to promote digital citizenship amongst our student body. Our
              ICT department staff provide support to both teachers and students in order for smooth integration of
              Educational Technologies. Professional Development is also provided to staff in areas of Educational
              Technology.
            </p>
            <img src={pedagogy} alt="Pedagogy" />
          </React.Fragment>
        )}
        {tab === 1 && (
          <React.Fragment>
            <h4>Years 1 - 3</h4>
            <p>
              Years 1 - 3 students have access to Macbook, Chromebook and iPad carts with a substantial number of
              devices so that teachers can integrate these resources to enhance their teaching and learning.
            </p>

            <h4>Years 4 - 6</h4>
            <p>
              Years 4 - 6 have a 1-to-1 Laptop program here at Kingston. Our 1-to-1 program ensures that students are
              equipped with this essential 21 Century Learning tool to use in their Transdisciplinary Units of Inquiry.
            </p>
            <p>
              Kingston remains committed to innovation in education and equips staff and students with the necessary
              tools and skills in order to utilize new technologies. Ongoing training is provided to staff on new
              initiatives within the school. With each new development we ensure to keep our community up to date every
              step of the way.
            </p>
            <p>
              The areas of Science, Technology, Engineering, Arts and Music are embedded across our Programme of
              Inquiry. The Arts and Music are taught by Specialist teachers who have a long history of expertise in both
              of these areas. Science, Technology and Engineering are embedded throughout our curriculum and are
              supported by our class teachers and members of our ICT department.
            </p>
            <p>
              Our addition of STEM/STEAM resources such as Beebots, Makey Makeys, Make-dos and more are available for
              teachers to book out at their convenience when integrating into our Programme of Inquiry.
            </p>
            <img src={ict} alt="ICT & commitment to innovation" />
          </React.Fragment>
        )}
      </ContentLayout>
    );
  }
}
